export const LOCATION_TAB_KEYS = {
  LOG: 'LOG_TAB',
  MODULE: 'MODULE_TAB',
  SUB_LOCATION: 'SUB_LOC_ID',
}

export const LOCATION_MODULE_KEYS = {
  BOLO: 'BOLO',
  EVENT: 'EVENT',
  INFO: 'INFO',
  LOG: 'LOG',
  LOG_CHECKPOINT: 'LOG_CHECKPOINT',
  LOG_ENTRY: 'LOG_ENTRY',
  MAP: 'MAP',
  PASS_DOWN: 'PASS_DOWN',
  RECORD: 'RECORD',
  REPORT: 'REPORT',
  STATS: 'STATS',
  SUB_LOCATION: 'SUB_LOCATION',
}

export const LOCATION_MODULE_LABELS = {
  BOLO: 'Bolos',
  EVENT: 'Events',
  INFO: 'Info',
  LOG: 'Logs',
  LOG_CHECKPOINT: 'Checkpoints',
  LOG_ENTRY: 'Entries',
  MAP: 'Map',
  PASS_DOWN: 'Pass Downs',
  RECORD: 'Records',
  REPORT: 'Reports',
  STATS: 'Stats',
  SUB_LOCATION: 'Sub Locations',
}

export const LOCATIONS_ROUTES = {
  __ROOT__: '/locations',
  VIEW_LOCATION: '/locations/view/:locationId',
}

export const LS_LOCATION_LAST_VISIT_KEY = 'portal__location_last_visit'
